<template>
  <button @click="onClick">
    <ChrevronDown
      :width="40"
      :iconColor="'rgba(15,28,112,1)'"
    />
  </button>
</template>

<script>
import ChrevronDown from '@/components/Icons/ChevronDown.vue';
export default {
  name: 'down-button',
  components: { ChrevronDown },
  props: { onClick: Function },
};
</script>

<style lang="scss" scoped>
button {
  position: absolute;
  bottom: 33px;
  left: 25%;
  margin-left: -46px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 92px;
  height: 92px;
  border-radius: 100%;
  background-color: #ffffff;
  box-shadow: 0 5px 35px 0 rgba(15, 28, 112, 0.3);
  border: none;
  cursor: pointer;
  z-index: 3;
  display: none;
  svg {
    margin-top: 10px;
  }
}

/* Tablet Landscape size */
@media only screen and (max-height: 790px) {
  button {
    display: block;
  }
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  button {
    left: 50%;
    bottom: 50px;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  button {
    display: none;
  }
}
</style>
